export const NOTICE_TOP_EXPOSURE = [
  { label: "상단노출 사용", value: "1" },
  { label: "상단노출 안함", value: "0" },
];

export const NOTICE_SHARE = [
  { label: "회사 공지사항", value: "notice" },
  { label: "세무사상담", value: "counseling" },
];
export const TAX_BOARD = [
  { label: "세무 공지", value: "tax_notice" },
  { label: "세무 뉴스", value: "tax_news" },
];